import React from "react";
import { Link } from "react-router-dom";
import processImage from './../assets/babyKnives.webp'; // Or any good process image

const ProcessPreview = () => {
  return (
    <section className="about-preview" aria-labelledby="process-preview-heading">
      <div className="process-container"> {/* ✅ Wrap text & image */}
        
        {/* ✅ Text Content */}
                {/* ✅ Image with Caption */}
        <div className="process-image">
            <img src={processImage} alt="Knife-making process" />
            <p className="image-caption" aria-hidden="true">Shaping blades in the early stages.</p>
        </div>

        <div className="process-content">
          <p>
            Every Knife is hand-crafted through a meticulous, hands-on process. 
            From forging and shaping high-quality steel to fitting exotic wood handles and custom leather sheaths, 
            our process ensures that each blade is both highly-functional and a beautiful work of art.
          </p>

          <div className="read-more">
            <Link to="/our-process" className="read-more-btn" aria-label="Learn more about our knife-making process">Explore Our Process <i className="fa-solid fa-arrow-right"></i></Link>
          </div>
        </div>



      </div>
    </section>
  );
};

export default ProcessPreview;